import { Input } from '../../../../common/Input'
import { formatDateForInput } from '../../../../utils/textUtils';

// Program Details Tab Component
export function ProgramDetailsTab({
  form,
  errorState,
  handleInputChange,
  handleFileChange,
  removeFile,
  filePreview,
  hasFile,
  getFileIcon
}) {
  return (
    <div className="rounded-lg border border-gray-300 bg-white px-4 shadow-sm">
      <div className="border-b border-gray-300 py-1">
        <h3 className="font-medium text-gray-700">Training/Seminar Information</h3>
      </div>
      <div className="grid grid-cols-1 gap-4 pb-3 pt-3">
        <Input
          label="Title:"
          value={form.title}
          onChange={(e) => handleInputChange('title', e.target.value)}
          placeholder="Enter training/seminar title"
          isRequired={true}
          error={errorState.title && !form.title}
          errorMessage="Please fill up this field"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            type="date"
            label="Date From:"
            value={formatDateForInput(form.dateFrom)}
            onChange={(e) => handleInputChange('dateFrom', e.target.value)}
            isRequired={true}
            error={errorState.dateFrom && !form.dateFrom}
            errorMessage="Please select a date"
          />

          <Input
            type="date"
            label="Date To:"
            value={formatDateForInput(form.dateTo)}
            onChange={(e) => handleInputChange('dateTo', e.target.value)}
            isRequired={true}
            error={errorState.dateTo && !form.dateTo}
            errorMessage="Please select a date"
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-600">
            File (Image or PDF):
          </label>
          <div className="flex flex-col items-center space-y-3">
            {filePreview ? (
              <>
                <img
                  src={filePreview}
                  alt="File Preview"
                  className="h-40 w-auto rounded border border-gray-300 object-contain"
                />
                <div className="flex items-center space-x-2">
                  <span className="text-sm text-gray-600">{form.fileData ? form.fileData.name : "File attached"}</span>
                  <button
                    type="button"
                    onClick={removeFile}
                    className="cursor-pointer rounded border-none bg-red-500 px-3 py-1 text-sm text-white hover:bg-red-600"
                  >
                    Remove
                  </button>
                </div>
              </>
            ) : hasFile ? (
              <div className="flex flex-col items-center space-y-2">
                <div className="text-4xl">{getFileIcon()}</div>
                <div className="text-sm text-gray-600">{form.fileName || "File attached"}</div>
                <div className="flex items-center space-x-2">
                  <span className="text-xs text-gray-500">{form.fileType || "File type unknown"}</span>
                  <button
                    type="button"
                    onClick={removeFile}
                    className="cursor-pointer rounded border-none bg-red-500 px-3 py-1 text-sm text-white hover:bg-red-600"
                  >
                    Remove
                  </button>
                </div>
              </div>
            ) : (
              <div className="flex h-40 w-full items-center justify-center rounded border-2 border-dashed border-gray-300 bg-gray-50">
                <span className="text-sm text-gray-500">No file selected</span>
              </div>
            )}

            <label className="cursor-pointer">
              <input
                type="file"
                accept="image/*,.pdf"
                onChange={handleFileChange}
                className="hidden"
                id="file-upload"
              />
              <div className="cursor-pointer rounded bg-blue-500 px-4 py-2 text-sm text-white hover:bg-blue-600">
                {hasFile ? "Change File" : "Upload File"}
              </div>
            </label>
            <span className="text-xs text-gray-500">Supported formats: JPG, PNG, PDF</span>
          </div>
        </div>

        <div className="flex items-center pt-2">
          <input
            type="checkbox"
            checked={form.isActive !== undefined ? form.isActive : true}
            onChange={(e) => handleInputChange('isActive', e.target.checked)}
            className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <label className="ml-2 text-sm font-medium text-gray-600">
            Active
          </label>
        </div>
      </div>
    </div>
  );
}